import last from '../array/last';

// sorts ids and groups consecutive ones into ranges: [1, 3, 5, 2] -> ["1-3", "5"]
const placeDEClassesIdsWithinRanges = (group: MaterialClassGrade[]): string[] => {
    const classesIds = group.map(({ id }) => id);

    const [firstClassId, ...restClassIds] = [...classesIds].sort((a, b) => a - b);

    const ranges = restClassIds.reduce<number[][]>(
        (ranges, id) => {
            const lastRange = last(ranges) as number[];
            const isConsecutive = id === (last(lastRange) as number) + 1;

            isConsecutive ? lastRange.push(id) : ranges.push([id]);

            return ranges;
        },
        [[firstClassId]]
    );

    return ranges.map((range) => (range.length === 1 ? `${range[0]}` : `${range[0]}-${last(range)}`));
};

export default placeDEClassesIdsWithinRanges;
